import type { ReaderFont } from './reader-fonts'

export type { ReaderFont } from './reader-fonts'
export { getFontFamilyCSS, READER_FONTS } from './reader-fonts'

export type ReaderTheme = 'light' | 'dark' | 'sepia'
export type EpubFlow = 'scrolled' | 'paginated' | 'continuous'

export type ReaderSettings = {
  marginLeft: number
  marginRight: number
  fontSize: number
  lineHeight: number
  fontFamily: ReaderFont
  theme: ReaderTheme
  flow: EpubFlow
  swipeEnabled: boolean
}

/** テーマごとの背景色・文字色・リンク色 */
export const getThemeColors = (theme: ReaderTheme) => {
  switch (theme) {
    case 'dark':
      return { backgroundColor: '#1a1a1a', textColor: '#e0e0e0', linkColor: '#6db3f2' }
    case 'sepia':
      return { backgroundColor: '#f4ecd8', textColor: '#5b4636', linkColor: '#8b5a2b' }
    case 'light':
    default:
      return { backgroundColor: '#ffffff', textColor: '#000000', linkColor: '#0066cc' }
  }
}

/** デフォルトのリーダー設定 */
export const DEFAULT_READER_SETTINGS: ReaderSettings = {
  marginLeft: 20,
  marginRight: 20,
  fontSize: 16,
  lineHeight: 1.6,
  fontFamily: 'original',
  theme: 'dark',
  flow: 'continuous',
  swipeEnabled: false,
}
